import React, { Component } from 'react';
import { connect } from 'react-redux';
import Question from './Question';
import { generateIdForCurioso, encodeCurioso, getDefaultCheckedIndex, getIsNextButtonDisabled } from '../lib/utilityFunctions';
import { PALETTES } from '../data/constants';
const questionsData = require('../content/questionsData.json');

class QuestionList extends Component {
  componentDidMount() {
    this.setThemeColors();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.questionIndex !== prevProps.match.params.questionIndex) {
      this.setThemeColors();
    }
  }

  setThemeColors = () => {
    const questionIndex = parseInt(this.props.match.params.questionIndex, 10) % PALETTES.length;
    const { dark, light } = PALETTES[questionIndex];

    const backgrounds = document.getElementsByClassName("QuestionBackground");
    for(let i = 0; i < backgrounds.length; i++) {
      backgrounds[i].style.setProperty('--light-color', light);
      backgrounds[i].style.setProperty('--dark-color', dark);
    }

    const permittedColors = PALETTES.filter((_, index) => index !== questionIndex);
    const blobs = document.getElementsByClassName("Blob");
    for(let i = 0; i < blobs.length; i++) {
      blobs[i].style.setProperty('--light-color-contrast', permittedColors[i % permittedColors.length].light);
      blobs[i].style.setProperty('--dark-color-contrast', permittedColors[i % permittedColors.length].dark);
      blobs[i].style.setProperty('--animation-delay', `-${i}s`);
    }
  }

  render() {
    const questionIndex = parseInt(this.props.match.params.questionIndex, 10);
    const { questionId, questionText, answerChoices } = questionsData.questions[questionIndex];

    const isFinalQuestion = questionIndex >= questionsData.questions.length-1;
    const linkTo = isFinalQuestion
      ? `/curioso/${this.props.encodedCurioso}` 
      : `/quiz/${questionIndex+1}`
    const linkText = isFinalQuestion
      ? "See Result!"
      : "Next >"

    return (<div className="Container QuestionBackground">    
      <Question
        questionId={questionId}
        questionText={questionText}
        answerChoices={answerChoices.map(choice => ({ id: choice.answerId, text: choice.answerText }))}
        defaultCheckedIndex={this.props.defaultCheckedIndex}
        nextRoute={linkTo}
      />
    </div>)
      
  }
}

const mapStateToProps = (state, ownProps) => ({
  encodedCurioso: encodeCurioso(generateIdForCurioso(state)),
  defaultCheckedIndex: getDefaultCheckedIndex(state, ownProps),
  isNextButtonDisabled: getIsNextButtonDisabled(state, ownProps),
});

export default connect(mapStateToProps)(QuestionList);